export default "__VITE_ASSET__CBb1HdPq__"